import {StoreExt} from '@utils/reactExt'
import {observable, action, runInAction} from 'mobx'
import moment from 'moment'

class PackageStore extends StoreExt {
    @observable packageList: any[] = []
    @observable loading: boolean = false
    @observable currentTab: string = 'toBeEffective'
    @action
    manualActive = async (data) => {
        await this.api.manualActive({orderId: data.orderId})
        this.getPackageList({iccid: data.iccid})
    }
    @action
    setCurrentTab = e => {
        this.currentTab = e
    }
    @action
    getPackageList = async ({apiName = 'queryUsePlan', iccid}) => {
        this.loading = true
        try {
            this.packageList = []
            const res = await this.api[apiName]({iccid})
            // 待生效套餐
            if (apiName === 'queryUsePlan') {
                res.map(item => {
                    if (moment(new Date()).diff(moment(item.startDate), 'days') >= 0 &&
                        moment(new Date()).diff(moment(item.endDate), 'days') <= 0 || item.inUse === 1) {
                        item.useStatus = 1   // 正在使用
                    } else if (moment(new Date()).diff(moment(item.startDate), 'days') < 0 || item.inUse === 0) {
                        item.useStatus = 0   // 未使用
                    }
                })
            }
            runInAction(() => {
                this.packageList = apiName === 'queryUsePlan' ? res.filter(item => item.useStatus !== 1) : res
            })
        } catch (e) {
        } finally {
            runInAction(() => {
                this.loading = false
            })
        }
    }
}

const packageStore = new PackageStore()
export {
    packageStore,
    PackageStore
}
